import { render, staticRenderFns } from "./banner-ope.vue?vue&type=template&id=63e45f87&scoped=true&"
import script from "./banner-ope.vue?vue&type=script&lang=js&"
export * from "./banner-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e45f87",
  null
  
)

export default component.exports